export default "__VITE_ASSET___72zWOnV__"